// extracted by mini-css-extract-plugin
export default {"detailsContainer":"Details_detailsContainer__0wgWT","columns":"Details_columns__tL0F0","image":"Details_image__BlfEi","text":"Details_text__ScnbF"};